import React, { ReactElement, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { setSessionItem } from '../../utils/sessionStorage'

import apis from '../../libs/services'

function Activation (): ReactElement {
  const navigate = useNavigate()
  const { code } = useParams()
  const [error, setError] = useState<string | undefined>()

  useEffect(() => {
    const checkUserActivation = async (): Promise<void> => {
      try {
        const res = await apis.checkUserActivation(code as string)

        if (res?.data?.error) {
          setError(res?.data?.error?.response?.data?.error_description || 'Activation failed!')
        } else {
          setSessionItem('userData', { ...res?.data?.data?.user || {}, code })
        }
      } catch (err: any) {
        setError(err?.response?.data?.error_description || 'Activation failed!')
      }
    }

    if (code) {
      checkUserActivation()
    } else {
      navigate('/')
    }
  }, [code, navigate])

  return (
    <div className='text-[#ff0000] text-[24px] font-primary w-screen h-screen flex items-center justify-center'>
      {error}
    </div>
  )
}

export default Activation
